
/**
 * Slick setup
 */
$(document).ready(function () {



    // ----------------------------------------------
    // Slides (http://kenwheeler.github.io/slick/)
    // ----------------------------------------------
    $('.slide-list').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        customPaging: function (slider, i) {
            return '<svg id="b70f3615-4d4f-4056-b053-fc5c33b1d398" data-name="Ebene 2" xmlns="http://www.w3.org/2000/svg" width="10.72"\n' +
                    '     height="15.53" viewBox="0 0 10.72 15.53">\n' +
                    '    \n' +
                    '    <title>Feder_Web</title>\n' +
                    '    <g>\n' +
                    '        <rect style="fill:currentColor" y="12.37" width="10.72" height="1.1" rx="0.13"/>\n' +
                    '        <rect style="fill:currentColor" y="10.31" width="10.72" height="1.1" rx="0.13"/>\n' +
                    '        <polygon style="fill:currentColor"\n' +
                    '                 points="5.51 11.51 3.02 12.27 5.46 12.27 8.01 11.51 5.51 11.51"/>\n' +
                    '        <rect style="fill:currentColor" y="14.43" width="10.72" height="1.1" rx="0.13"/>\n' +
                    '        <polygon style="fill:currentColor"\n' +
                    '                 points="5.51 13.57 3.02 14.33 5.46 14.33 8.01 13.57 5.51 13.57"/>\n' +
                    '        <polygon style="fill:currentColor" points="5.51 9.44 3.02 10.21 5.46 10.21 8.01 9.44 5.51 9.44"/>\n' +
                    '        <rect style="fill:currentColor" y="8.24" width="10.72" height="1.1" rx="0.13"/>\n' +
                    '        <rect style="fill:currentColor" y="6.18" width="10.72" height="1.1" rx="0.13"/>\n' +
                    '        <polygon style="fill:currentColor" points="5.51 7.38 3.02 8.15 5.46 8.15 8.01 7.38 5.51 7.38"/>\n' +
                    '        <polygon style="fill:currentColor" points="5.51 5.32 3.02 6.09 5.46 6.09 8.01 5.32 5.51 5.32"/>\n' +
                    '        <rect style="fill:currentColor" y="4.12" width="10.72" height="1.1" rx="0.13"/>\n' +
                    '        <rect style="fill:currentColor" y="2.06" width="10.72" height="1.1" rx="0.13"/>\n' +
                    '        <rect style="fill:currentColor" width="10.72" height="1.1" rx="0.13"/>\n' +
                    '        <polygon style="fill:currentColor" points="5.51 3.26 3.02 4.03 5.46 4.03 8.01 3.26 5.51 3.26"/>\n' +
                    '        <polygon style="fill:currentColor" points="5.51 1.2 3.02 1.97 5.46 1.97 8.01 1.2 5.51 1.2"/>\n' +
                    '    </g>\n' +
                    '</svg>';
        },
        nextArrow: '<div class="slide-control next"></div>',
        prevArrow: '<div class="slide-control prev"></div>',
        slide: '.slide',
        arrows: false,
        dots: true,
        autoplay:true,
        autoplaySpeed:7000,
        fade: true,
        cssEase: 'linear'
    });



    // ----------------------------------------------
    // Carousel (http://kenwheeler.github.io/slick/)
    // ----------------------------------------------
    $('.portletCarousel').slick({
        infinite: true,
        slidesToShow: 6,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1400,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: false
                }
            },
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: false
                }
            },
            {
                breakpoint: 1000,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: false
                }
            }
            // {
            //     breakpoint: 300,
            //     settings: {
            //         slidesToShow: 1,
            //         slidesToScroll: 1,
            //         dots: false
            //     }
            // }
            // You can unslick at a given breakpoint now by adding:
            // settings: "unslick"
            // instead of a settings object
        ],
        // arrows: true,
        nextArrow: '<div class="slide-control next"></div>',
        prevArrow: '<div class="slide-control prev"></div>',
        dots: false
        //variableWidth: true
    });

});

